import React from 'react';
import BasePage from '../../baseClasses/BasePage';
import AoErrorLogo from '../../assets/images/ao-error-logo.png';
import dataModel from '../../models/DataModel';

import miscFunctions from '../../helpers/misc-functions';

import './ErrorPage.scss';
class ErrorPage extends BasePage {
  componentDidMount() {
    super.componentDidMount();
  }

  handleClick(e){
    if (this.props.type == 'transparent'){
      dataModel.inProgress = 0;
    }
  }

  render() {

    const { catastrophicError } = this.props;
    let errorTitle = catastrophicError.action;
    let errorMessage = catastrophicError.message;
    if (miscFunctions.isUserOnIe()) {
      errorTitle = 'You are using an unsupported browser';
      errorMessage = 'Internet Explorer is not a supported browser. For the best experience, please use Chrome.';
    }

    return (
      <div className="error-page">
        <div className="error-page__header">Whoops! Something's gone wrong.</div>
        <img alt="Logo" className="error-page__logo" src={AoErrorLogo} />
        <div className="error-page__details">
            <p className='title'>{errorTitle}</p>
            <p className='message'>{errorMessage}</p>
        </div>
        
      </div>
      
    );
  }
}

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/containers/ErrorPage/index.js